import React from "react"
import { Link } from "gatsby"

const BreadCrumbs = ({ animal, brand, family, recipe }) => {
    return(
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">{animal}</Link></li>
                <li className="breadcrumb-item"><Link to="/">{brand}</Link></li>
                <li className="breadcrumb-item active" aria-current="page">{brand} {recipe}</li>
            </ol>
        </nav>
    )
}

export default BreadCrumbs